export enum InvoiceTabs {
  DETAILS = "Details",
  PURCHASE_ORDERS = "Purchase Orders",
}
